export default "__VITE_ASSET__Lmih1juk__"